import { useMemo } from 'react';

import {
  BREAKPOINT_FULL_HD,
  BREAKPOINT_HD_PLUS,
  BREAKPOINT_LG,
  BREAKPOINT_XGA,
} from '../../../constants/styles';

export function useCalculatePaddingYAxis() {
  const currentInnerWidth = window.innerWidth;
  return useMemo(() => {
    if (currentInnerWidth < BREAKPOINT_XGA) {
      return 10;
    }
    if (currentInnerWidth < BREAKPOINT_LG) {
      return 25;
    }
    if (currentInnerWidth < BREAKPOINT_HD_PLUS) {
      return 35;
    }
    if (currentInnerWidth < BREAKPOINT_FULL_HD) {
      return 45;
    }
    if (currentInnerWidth >= BREAKPOINT_FULL_HD) {
      return 50;
    }
  }, [currentInnerWidth]);
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/TimeScalableChart/useCalculatePaddingYAxis.jsx